<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">All Receipts</h4>
                                <h6 class="card-subtitle">Search receipts customer</h6>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <button class="btn btn-success waves-effect waves-light" data-target="#newReceiptModal" data-toggle="modal" type="button">
                                            <i class="fas fa-plus"></i> New Receipt
                                        </button>
                                        <div aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade" id="newReceiptModal" role="dialog" tabindex="-1">
                                            <div class="modal-dialog modal-lg" role="document">
                                                <div class="modal-content">
                                                    <form @submit.prevent="handleSubmit('new_receipt_form')" data-vv-scope="new_receipt_form">
                                                        <div class="modal-header">
                                                            <h4 class="modal-title" id="myModalLabel">New Receipt</h4>
                                                            <button aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                                                        </div>
                                                        <div class="modal-body card-blue">
                                                            <div class="card-body">
                                                                <div class="form-group row">
                                                                    <label class="col-sm-3 text-right control-label col-form-label" for="partner">Seller</label>
                                                                    <div class="col-sm-7">
                                                                        <multiselect
                                                                                :class="{'is-invalid': submitted && errors.has('partner')}"
                                                                                :clear-on-select="false"
                                                                                :close-on-select="true"
                                                                                :hide-selected="true"
                                                                                :internal-search="false"
                                                                                :limit="3"
                                                                                :loading="isLoading"
                                                                                :max-height="600"
                                                                                :options="sellerOptions"
                                                                                :options-limit="300"
                                                                                :searchable="true"
                                                                                :show-no-results="false"
                                                                                @search-change="searchSellers"
                                                                                class="form-control"
                                                                                data-vv-as="partner"
                                                                                id="partner"
                                                                                label="partner"
                                                                                name="partner"
                                                                                open-direction="bottom"
                                                                                placeholder="Search Partners"
                                                                                track-by="id"
                                                                                v-model="receipt.partner"
                                                                                v-validate="'required'">
                                                                            <template slot="singleLabel" slot-scope="props">
                                                                                <div class="option__desc">
                                                                                    <div class="option__desc">
                                                                                        {{ props.option.biz_name }}
                                                                                    </div>
                                                                                </div>
                                                                            </template>
                                                                            <template slot="option" slot-scope="props">
                                                                                <div class="option__desc">
                                                                                    <div class="option__desc" v-if="props.option">
                                                                                        <h5>{{ props.option.biz_name }}</h5>
                                                                                        <h6>{{ props.option.line1}}</h6>
                                                                                        <h6>{{ props.option.city+', '+ props.option.country}}</h6>
                                                                                    </div>
                                                                                    <div class="option__desc" v-else>
                                                                                        <h5>Add New</h5>
                                                                                    </div>
                                                                                </div>
                                                                            </template>
                                                                            <template slot="afterList">
                                                                                <div class="col-xs-12">
                                                                                    <router-link :to="{name: 'addpartner'}" class="btn btn-block btn-lg btn-outline-success">
                                                                                        <i class="fa fa-plus-circle"></i>&nbsp;Add Customer
                                                                                    </router-link>
                                                                                </div>
                                                                            </template>
                                                                        </multiselect>
                                                                        <div class="invalid-feedback" v-if="submitted && errors.has('partner')">{{ errors.first('partner') }}</div>
                                                                    </div>
                                                                </div>
                                                                <div class="form-group row">
                                                                    <label class="col-sm-3 text-right control-label col-form-label" for="currency">Currency</label>
                                                                    <div class="col-sm-7">
                                                                        <div :class="{'is-invalid': submitted && errors.has('currency')}" class="form-control p-0-0">
                                                                            <currency-select @currency-select="setCurrency"
                                                                                             data-vv-as="currency"
                                                                                             id="currency"
                                                                                             name="currency"
                                                                                             ref="reference"
                                                                                             v-model="receipt.currency"
                                                                                             v-validate="'required'">
                                                                            </currency-select>
                                                                        </div>
                                                                        <div class="invalid-feedback" v-if="submitted && errors.has('currency')">{{ errors.first('currency') }}</div>
                                                                    </div>
                                                                </div>
                                                                <div class="form-group row">
                                                                    <label class="col-sm-3 text-right control-label col-form-label" for="amount">Amount</label>
                                                                    <div class="col-sm-7">
                                                                        <input :class="{'is-invalid': submitted && errors.has('amount')}"
                                                                               class="form-control"
                                                                               id="amount"
                                                                               name="amount"
                                                                               step="any"
                                                                               type="number"
                                                                               v-model="receipt.amount"
                                                                               v-validate="'required'">
                                                                        <div class="invalid-feedback" v-if="submitted && errors.has('amount')">{{ errors.first('amount') }}</div>
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label class="col-sm-3 text-right control-label col-form-label" for="attachment">Attachment</label>
                                                                    <div class="col-sm-7">
                                                                        <input @change="handleFileChange"
                                                                               class="form-control-file"
                                                                               id="attachment"
                                                                               name="attachment"
                                                                               ref="attachment"
                                                                               type="file">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label class="col-sm-3 text-right control-label col-form-label" for="notes">Payment Date</label>
                                                                    <div class="col-sm-7 input-group mb-3">
                                                                        <div class="input-group-prepend">
                                                                            <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                                                                        </div>
                                                                        <input :class="{'is-invalid': submitted && errors.has('payment_date')}"
                                                                               autocomplete="off"
                                                                               class="form-control"
                                                                               data-vv-as="payment_date"
                                                                               id="payment_date"
                                                                               name="payment_date"
                                                                               placeholder="mm/dd/yyyy"
                                                                               style="height: 42px;"
                                                                               type="text"
                                                                               v-model="receipt.payment_date"
                                                                               v-validate="'required'">
                                                                        <div class="invalid-feedback" v-if="submitted && errors.has('payment_date')">{{ errors.first('payment_date') }}</div>
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label class="col-sm-3 text-right control-label col-form-label" for="notes">Notes</label>
                                                                    <div class="col-sm-7">
                                                                        <textarea class="form-control"
                                                                                  data-vv-as="amount"
                                                                                  id="notes"
                                                                                  name="notes"
                                                                                  v-model="receipt.notes">
                                                                        </textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="modal-footer">
                                                            <button class="btn waves-effect waves-light btn-success" type="submit">Submit</button>
                                                            <button @click="reset()" class="btn waves-effect waves-light btn-dark" type="button">Reset</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-if="receipts.length>0">
                        <form>
                            <div class="form-row">
                                <div class="form-group col-md-4">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('partner')}"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :loading="isLoading"
                                            :max-height="600"
                                            :options="buyers"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @input="selectBuyer()"
                                            @search-change="searchBuyers"
                                            class="form-control"
                                            data-vv-as="buyer"
                                            id="buyer"
                                            label="buyer"
                                            name="buyer"
                                            open-direction="bottom"
                                            placeholder="Search Buyer"
                                            track-by="id"
                                            v-model="buyer"
                                            v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.biz_name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.biz_name }}</h5>
                                                    <h6>{{ props.option.line1}}</h6>
                                                    <h6>{{ props.option.city+', '+ props.option.country}}</h6>
                                                </div>
                                                <div class="option__desc" v-else>
                                                    <h5>Add New</h5>
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                </div>
                                <!--<div class="form-group col-md-2">-->
                                    <!--<select class="custom-select" id="inlineFormCustomSelect" style="height: 42px;" v-model="filter.status">-->
                                        <!--<option value="">Choose Status</option>-->
                                        <!--<option-->
                                                <!--v-bind:key="index"-->
                                                <!--v-bind:value="s"-->
                                                <!--v-for="(s, index) in statuses">{{s | capitalize}}-->
                                        <!--</option>-->
                                    <!--</select>-->
                                <!--</div>-->
                                <div class="form-group col-md-4">
                                    <input
                                            class="form-control"
                                            name="purchase"
                                            placeholder="Bill #"
                                            style="height: 42px;"
                                            type="text"
                                            v-model="filter.billid">
                                </div>
                                <div class="form-group col-md-4">
                                    <div class="input-group mb-2" id="drp">
                                        <v-md-date-range-picker
                                                :auto-apply="false"
                                                :end-date="endDate"
                                                :opens="opens"
                                                :show-activator-bar="false"
                                                :show-activator-label="false"
                                                :show-custom-range-label="value"
                                                :start-date="startDate"
                                                @change="change"
                                                show-year-select>
                                        </v-md-date-range-picker>
                                        <div class="input-group-append">
                                            <button @click="searchReceipts(1)" class="btn btn-light btn-outline-success custom-go" type="button">Go!</button>
                                            <button @click="reset()" class="btn btn-light btn-outline-secondary btn-arrange" style="height: 42px;" type="button">Reset!</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="table-responsive m-t-30">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label class="col-form-label" for="records" style="padding-left: 10px;">Display Maximum</label>
                                    <div class="col-sm-2" style="padding-top: 5px;">
                                        <select @change="perPageRecordChange()" aria-controls="lang_opt" class="form-control form-control-sm" id="records" name="lang_opt_length" v-model="perPage">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <label class="col-form-label" for="records">Records per page</label>
                                </div>
                            </div>
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0" style="width: 0px;">
                                        <div class="form-check">
                                            <input
                                                    @change="checkAll($event)"
                                                    class="form-check-input"
                                                    id="checkAll"
                                                    type="checkbox">
                                            <label class="form-check-label" for="checkAll"></label>
                                        </div>
                                    </th>
                                    <th class="border-0"><h6>#</h6></th>
                                    <th class="border-0"><h6>Seller</h6></th>
                                    <th class="border-0"><h6>Total</h6></th>
                                    <th class="border-0"><h6>Payment Date</h6></th>
                                    <th class="border-0"><h6>Attachments</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(r, index) in receipts">
                                    <td class="sorting_1">
                                        <div class="form-check">
                                            <input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    v-bind:id="r.id"
                                                    v-bind:value="r"
                                                    v-model="checkedBills">
                                            <label class="form-check-label" v-bind:for="r.id"></label>
                                        </div>
                                    </td>
                                    <td>{{index+1}}</td>
                                    <td>{{r.seller.biz_name | capitalize}}</td>
                                    <td>{{r.total | money}}</td>
                                    <td>{{r.payment_date | date}}</td>
                                    <td>
                                        <ul style="list-style: none" v-if="r.attachments.length > 0">
                                            <li :key="i" v-for="(a, i) of r.attachments">
                                                <a @click="downloadFile(a.filepath, a.filename)" href="javascript:void(0)">{{a.filename}}</a>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                            <div class="hide" id="invoice-summary-table">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Invoice Id</th>
                                        <th>Partner</th>
                                        <th>Status</th>
                                        <th>Price</th>
                                        <th>Created at</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <!--<tr v-bind:key="index" v-for="(cinv, index) in checkedInvoices">-->
                                    <!--<td>{{index+1}}</td>-->
                                    <!--<td>{{cinv.id}}</td>-->
                                    <!--<td v-if="currentOrg.type === 'COOP'">{{cinv.buyer.biz_name}}</td>-->
                                    <!--<td v-if="currentOrg.type === 'COOP_MEMBER'">{{cinv.seller.biz_name}}</td>-->
                                    <!--<td>{{cinv.status}}</td>-->
                                    <!--<td>{{cinv.total | money}}</td>-->
                                    <!--<td>{{cinv.created_at | timestamp}}</td>-->
                                    <!--</tr>-->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="card-body card-blue" v-else>
                        <h4 class="card-title text-muted text-center">No records found</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import Multiselect from 'vue-multiselect';
    import moment from 'moment';
    import _ from 'lodash';
    import JsonCSV from 'vue-json-csv';
    import CurrencySelect from "../../../protected/common/CurrencySelect";
    import axios from "axios";

    export default {
        name: "Receipts",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Multiselect, Paginate, JsonCSV, CurrencySelect},
        data() {
            return {
                submitted: false,
                isLoading: false,
                statuses: ['UNPAID', 'PAID'],
                buyers: [],
                filter: {
                    buyer_id: null,
                    status: "",
                    fromDate: "",
                    toDate: "",
                    billid: ""
                },
                buyer: null,
                startDate: moment(new Date()).format('YYYY-MM-DD'),
                endDate: moment(new Date()).format('YYYY-MM-DD'),
                receipts: [],
                pageCount: 1,
                total: 0,
                opens: 'right',
                value: true,
                checkedBills: [],
                exportedBills: [],
                inv_export_name: "Invoice_Report.csv",
                perPage: 10,
                isFiltered: false,
                sellerOptions: [],
                receipt: {
                    partner: null,
                    amount: null,
                    currency: {
                        id: null,
                        name: null,
                        symbol: null
                    },
                    attachments: [],
                    notes: null,
                    payment_date: null,
                }
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                jQuery('#payment_date').datepicker({
                    constrainInput: true,
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.receipt.payment_date = event.target.value;
                });

                await this.getReceipts();
            },
            perPageRecordChange() {
                if(this.isFiltered) {
                    this.searchBills(1);
                } else {
                    this.getBills(1);
                }
            },
            async getReceipts(page) {
                try {
                    $(".preloader").fadeIn();
                    let reply = await this.$http.get(`/express/${this.currentOrg.express_id}/receipts`, {
                        params: {
                            page: page,
                            perPage: this.perPage
                        }
                    });
                    $(".preloader").fadeOut();

                    this.isFiltered = false;
                    this.total      = reply.data.total;
                    this.receipts   = reply.data.bills;
                    let max_date    = reply.data.min_date;
                    let min_date    = reply.data.max_date;
                    if(min_date && max_date) {
                        this.startDate = moment(max_date).format('YYYY-MM-DD');
                        this.endDate   = moment(min_date).format('YYYY-MM-DD');
                    } else if(this.bills.length === 1) {
                        this.startDate = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                        this.endDate   = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                    } else {
                        this.startDate = moment(new Date()).format('YYYY-MM-DD');
                        this.endDate   = moment(new Date()).format('YYYY-MM-DD');
                    }
                    this.setPageCount();
                } catch(e) {
                    $(".preloader").fadeOut();
                }
            },
            pageHandler(pageNum) {
                this.getTransfers(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            checkAll(e) {
                if(e.target.checked) {
                    this.checkedBills = this.invoices
                } else {
                    this.checkedBills = []
                }
            },
            change(e) {
                this.filter.fromDate = e[0].toDate();
                this.filter.toDate   = e[1].toDate();
            },
            async searchBuyers(searchText) {
                try {
                    this.isLoading = true;
                    let reply      = await this.$http.get("/express/" + this.currentOrg.express_id + "/partner/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.buyers    = reply.data;
                    this.isLoading = false;
                } catch(e) {
                    console.log(err);
                }
            },
            selectBuyer() {
                this.filter.buyer_id = this.buyer.id;
            },
            async searchReceipts(page) {
                try {
                    let reply     = await this.$http
                    .get(`/express/${this.currentOrg.express_id}/invoices/${JSON.stringify(this.filter)}/search`, {
                        params: {
                            page: page,
                            perPage: this.perPage
                        }
                    });
                    this.total    = reply.data.total;
                    this.receipts = reply.data.bills;
                    let max_date  = reply.data.min_date;
                    let min_date  = reply.data.max_date;
                    if(min_date && max_date) {
                        this.startDate = moment(max_date).format('YYYY-MM-DD');
                        this.endDate   = moment(min_date).format('YYYY-MM-DD');
                    } else if(this.bills.length === 1) {
                        this.startDate = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                        this.endDate   = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                    } else {
                        this.startDate = moment(new Date()).format('YYYY-MM-DD');
                        this.endDate   = moment(new Date()).format('YYYY-MM-DD');
                    }
                    this.isFiltered = true;
                    this.setPageCount();
                } catch(e) {
                    console.log(e);
                }
            },
            async searchSellers(searchText) {
                try {
                    this.isLoading     = true;
                    let reply          = await this.$http.get("/express/" + this.currentOrg.express_id + "/partner/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.sellerOptions = reply.data;
                    this.isLoading     = false;
                } catch(e) {
                    console.log(e);
                }
            },
            setCurrency(e) {
                if(e) {
                    this.receipt.currency.id     = e.id;
                    this.receipt.currency.name   = e.name;
                    this.receipt.currency.symbol = e.symbol;
                }
            },
            async handleFileChange(e) {
                let file        = this.$refs.attachment.files[0];
                let filename    = file.name;
                let contenttype = file.type.split('/')[1];

                // get signed url and upload file to s3;

                let reply = await this.$http.get(`express/${this.currentOrg.express_id}/receipts/signedUrl`, {
                    params:
                    {
                        type: 'write',
                        filename: filename,
                        contenttype: contenttype
                    }
                });

                this.receipt.attachments = [{
                    documentid: reply.data.documentid,
                    filename,
                    contenttype,
                    filepath: reply.data.key,
                    url: reply.data.url
                }];

                await axios.put(reply.data.url, file);
            },
            handleSubmit(scope) {
                this.submitted = true;
                this.$validator.validateAll(scope)
                .then(valid => {
                    if(valid) {
                        this.save();
                    }
                })
            },
            async save() {
                try {
                    await this.$http.post(`express/${this.currentOrg.express_id}/receipts`, this.receipt);
                    this.$toastr('success', 'Receipt uploaded', 'Success');
                    $('#newReceiptModal').modal('toggle');
                    this.getReceipts(1);
                    this.reset();
                } catch(e) {
                    this.$toastr('error', 'Failed to upload receipt', 'Failed');
                }
            },
            async downloadFile(filepath, filename) {
                let reply = await this.$http.get(`express/${this.currentOrg.express_id}/receipts/signedUrl`, {
                    params: {
                        type: 'read',
                        filepath: filepath,
                        filename: filename
                    }
                });
                let link = document.createElement('a');
                link.href = reply.data.url;
                link.download = filename;
                link.click();
            },
            reset() {
                this.receipt = {
                    partner: null,
                    amount: null,
                    currency: {
                        id: null,
                        name: null,
                        symbol: null
                    },
                    attachments: [],
                    notes: null,
                    payment_date: null,
                }
            }
        }
    }
</script>

<style scoped>

</style>
